export default [
    {
        path: 'share-team',
        component: () => import(/* webpackChunkName: "share-team" */ './index.vue'),
        children: [
            {
                path: '/',
                redirect: 'team-content',
            },
            {
                path: 'team-content/:id?',
                name: '纷享号内容',
                component: () => import(/* webpackChunkName: "share-team" */ './share-team-content.vue'),
            },
            {
                path: 'team-column',
                name: '纷享号专栏',
                component: () => import(/* webpackChunkName: "share-team" */ './share-team-column.vue'),
            },
            {
                path: 'team-column-detail',
                name: '纷享号专栏详情',
                component: () => import(/* webpackChunkName: "share-team" */ './share-team-column-detail.vue'),
            },
        ],
    },
];
